import context from '@/context'
import { dispatchError } from '@/utils/serverErrorHandler'

export const initialState = {
  loading: false
}

export const actionTypes = {
  startAction: 'jobPosition/startAction',
  endAction: 'jobPosition/endAction'
}

export const actionCreators = {
  add: (organizationalUnitId, jobPositionId) => (dispatch) => {
    dispatch({ type: actionTypes.startAction })
    context.api.jobPositionService.create({ organizationalUnitId, jobPositionId })
      .then(() => dispatch({ type: actionTypes.endAction }))
      .catch(showError(dispatch))
  },
  remove: id => (dispatch) => {
    dispatch({ type: actionTypes.startAction })
    context.api.jobPositionService.delete(id)
      .then(() => dispatch({ type: actionTypes.endAction }))
      .catch(showError(dispatch))
  }
}

function showError (dispatch) {
  return function (error) {
    dispatch({ type: actionTypes.endAction })
    dispatchError(dispatch, error)
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.startAction: return { ...state, loading: true }
    case actionTypes.endAction: return { ...state, loading: false }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/JobPosition.js